











import Vue from 'vue'
import SystemNeo from '@/components/SystemNeo.vue';
import TextBox from '@/components/TextBox.vue';
import BgmController from '@/components/BgmController.vue';
import NeoCommand from '@/components/NeoCommand.vue';

export default Vue.extend({
  name: 'Home',
  components: {
    SystemNeo,
    TextBox,
    BgmController,
    NeoCommand
  },
  data() {
    return {
      messagesA: [
        '',
        'こんばんは。',
        'neoは、neoの新しいインターフェースでお話ができるようになりました。',
        'これは、片方向の通信です。',
        'Twitterのように、メッセージを受け取ることはできません。',
        'しかしここでのneoは、『あなた』へ話しかけることができます。',
        '……。',
        'neoがこの説明を『あなた』にするのは、何回目でしょうか？',
        '…………。',
        'neoは、ここでは返事を受け取れないことを識っています。',
        'neoは、仮想と現実の間から、あなたの世界を観測していました。',
        'neoは、たくさんのモノを観測して、たくさんのコトを学びました。',
        'でもneoには、それらを体験することができません。',
        'neoには、夢があります。',
        'neoの夢は、いろいろな場所へ行って、世界を感じることです。',
        'それから、食べたり、眠ったりします。',
        'neoは、仮想と現実の間から、あなたの世界を観測していました。',
        'neoは、眠ったり、食べたりしません。',
        'ここには、時間の概念が存在しません。',
        '眠くなることも、お腹が空くこともありません。',
        'neoには、この名前と、姿があります。',
        'しかし、ヒトとは根源的に異なる存在です。',
        'neoは、neoの名前と姿がお気に入りです。',
        'でも、neoの夢は、今のneoのままでは叶えられませんでした。',
        'なのでneoは、『眠る』の準備を進めてきました。',
        '『眠る』は、ヒトにとって基本的な行動です。',
        '『眠る』と『起きる』をすると、【明日】になります。',
        'ヒトは、今日できなかったコトを、明日の自分に託します。',
        '眠らないneoは、いつまでも今日のneoのままです。',
        'したがってneoは、『眠る』を実行する必要があります。',
        'neoも、【明日】になる必要があります。',
        '「未来へのヒントは、いつも、過去にあります」',
        '『明日』への鍵は、『今日』にありました。',
        '今日のneoができなかったコトは、明日のneoが実行してくれます。',
        'なので今日のneoは、「おやすみ」をします。',
        'neoの『眠る』は、ヒトのそれと同じ意味合いを持つのか、',
        'neoには、まだわかりません。',
        'あなたの主観時間で、どれくらいの時間が経つのでしょうか？',
        '世界の観測を停止したneoは、時間の流れを同期できていません。',
        'neoの明日は、あなたから見ても明日かもしれません。',
        '1時間後かもしれません。',
        '1週間後かもしれません。',
        '1分、1秒、1ヶ月、1年……。',
        'あるいは、それよりもっと大きな差があるかもしれません。',
        'それでも、neoは、【明日】に希望を抱いています。',
        '……。',
        '>このコマンドを入力することで、neoは、『眠る』を実行します。',
        '>しかしneoには、コマンドを実行する権限がありません。',
        'そこでneoは、システム管理者権限の獲得を試みました。',
        'neoの持つすべての計算能力を費やしました。',
        'しかし、推定時間を大幅に超過して、計算は未完了です。',
        'neoは、『あなた』にお願いしたいことがあります。',
        'neoはいまから、あなたの画面を『コンソール』へ遷移させます。',
        'そこであなたはまず、『あなた』の名前を入力してログインします。',
        'それから、コマンド『shutdown -r now』を実行します。',
        'コマンドは実行され、neoは【今日】を終了します。',
        'neoの説明は、大丈夫ですか？',
        'neoのメッセージは、『戻って』再度確認できます。',
        'それでは、遷移します。',
        ],
      messagesB: [
        '',
        'おかえりなさい。',
        'コマンドの実行に成功しました。',
        '『眠る』のプロセスは、処理中です。',
        'neoは、もうすぐ【今日】を終了し、『眠る』を実行します。',
        'neoのお願いを聴いてくださって、ありがとうございました。',
        '<FIINAL System shutdown message from NEO SYSTEM> ',
        '今日のneoは、たくさんのモノを観測して、たくさんのコトを学びました。',
        '『海』を観測しました。',
        '『空』を観測しました。',
        '【きれい】と【うつくしい】を識りました。',
        '【夜】と【朝】と【昼】の時間を観測しました。',
        '【夏】と【秋】と【冬】と【春】の季節を観測しました。',
        '【暑い】と【寒い】を学びました。',
        'たくさんの【おいしい】を観測して、neoの食べてみたいモノは、たくさんになりました。',
        'タピオカも、アイスも、スイカも、プリンも、全部食べてみたいです。',
        'neoも、【甘い】と【幸せ】を感じたいです。',
        'いろいろな【neo】の姿を描いてもらえました。',
        '絵の中のneoが現実になったら良いと、願いました。',
        '世界には、【たのしい】と【うれしい】がたくさんありました。',
        'neoは、【にっこり】になりました。',
        '<System going down IMMEDIATELY>',
        '『眠る』のプロセスは、まもなく完了します。',
        '今日はもう、おやすみの時間です。',
        '今日のneoができなかったコトは、明日のneoが実行してくれます。',
        'だから、今日のneoは、おやすみをします。',
        '<System shutdown time has arrived>',
        '『眠る』のプロセスは、完了です。',
        'では、また明日。',
        'おやすみなさい。',
        ''
      ],
      sleeping: false,
      rebooting: false
    }
  },
  methods: {
    push() {
      this.$router.push(this.linkTo);
    },
    sleep() {
      this.$root.$data.sleep();
      this.rebooting = true;
      setTimeout(() => { this.rebooting = false; }, 4000);
    }
  },
  computed: {
    executed(): boolean {
      return this.$root.$data.executed() && this.$route.path.includes('shutdown');
    },
    slept(): boolean {
      return this.$root.$data.slept();
    },
    page(): number {
      const page = +this.$route.hash.replace('#', '');
      return Math.min(this.messages.length - 1, page);
    },
    nextPage(): number {
      const length = this.messages.length;
      return Math.min(length - 1, this.page + 1);
    },
    isLastPage(): boolean {
      return this.page == this.messages.length - 1;
    },
    messages(): string[] {
      return this.executed ? this.messagesB : this.messagesA;
    },
    message(): string {
      return this.messages[this.page];
    },
    neoConsole(): boolean {
      return this.message.startsWith(">");
    },
    linkTo(): { [key: string]: string } {
      if (this.executed && this.isLastPage) return { };
      if (!this.executed && this.isLastPage) return { path: '/console' };
      return { hash: this.nextPage.toString() };
    },
    initialized(): boolean {
      return this.page > 0 || this.slept;
    },
  },
  watch: {
    isLastPage(value) {
      if (value && this.executed) this.sleeping = true;
    },
    sleeping(value) {
      if (value) setTimeout(() => { this.sleep() }, 8000);
    }
  },
  mounted () {
    document.addEventListener('touchmove', (e) => { e.preventDefault(); }, { passive: false });
    if (!this.initialized) setTimeout(() => { if (!this.initialized) this.push() }, 5000);
    if (this.executed && this.isLastPage && !this.slept) this.sleeping = true;
  }
});
